import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { BijlageTemplatesByProcesstap } from '../../../templates/components/BijlageTemplatesByProcesstap'
import { StyledError } from '../../../theme/components/StyledError'
import { useTemplatesSearch } from '../hooks/useTemplatesSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { ContractinstellingenBijlagen }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenBijlagen = ({ filters }: Props) => {
  const {
    data: { bijlageTemplates },
    isLoading,
    error,
  } = useTemplatesSearch({ externalFilters: filters })

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <BijlageTemplatesByProcesstap templates={bijlageTemplates} />

      {!isLoading && bijlageTemplates.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
